module.exports = __webpack_public_path__ + "media/images/banner/coupons/coupon-zh-hant-e98f821590d56417d27a384027b257ce.png";